import apiClient from '../../shared/services/apiClient';

/**
 * Dashboard Service (User Version) — /api/user/dashboard/*
 */
class DashboardService {
  /** Legacy aggregate (v1 首页)，保留兼容。 */
  async getOverview() {
    try {
      const response = await apiClient.get('/api/user/dashboard/overview');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * v2 小组件：{ widgets: { <key>: {ok, data|error, at} } }，每个 key 独立成败。
   * @param {string[]} keys
   * @param {{cdn_range?: '24h'|'7d', refresh?: boolean}} opts
   */
  async getWidgets(keys, opts = {}) {
    const params = { keys: keys.join(',') };
    if (opts.cdn_range) params.cdn_range = opts.cdn_range;
    if (opts.refresh) params.refresh = 1;
    const response = await apiClient.get('/api/user/dashboard/widgets', { params });
    if (!response.data?.success) throw new Error(response.data?.error || 'load failed');
    return response.data.data?.widgets || {};
  }

  /** → { persisted: bool, layout: object|null } */
  async getLayout() {
    const response = await apiClient.get('/api/user/dashboard/layout');
    return response.data?.data || { persisted: false, layout: null };
  }

  /** layout=null → 恢复默认（服务端删除记录） */
  async saveLayout(layout) {
    const body = layout ? { layout } : { reset: true };
    const response = await apiClient.post('/api/user/dashboard/layout', body);
    return response.data?.data || { persisted: false };
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
